<template>
    <div class="automation-listing-table-actions">
        <CompassMenu
            ref="refMenuActions"
            trigger="click"
            customClass="automation-listing-table-actions__menu"
        >
            <CompassIconButton icon="action" />
            <template slot="dropdown">
                <CompassMenuItem :label="$t.__('common.actions.edit')" @click="handleEdit" />
                <CompassMenuItem
                    :label="$t.__('common.actions.duplicate')"
                    @click="handleDuplicate"
                />
                <CompassMenuItem :label="$t.__('common.actions.delete')" @click="handleDelete" />
            </template>
        </CompassMenu>
    </div>
</template>

<script>
import { duplicateAutomation } from 'api/automation/automationService.js';

import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;
const { mapState: mapStateSystem } = createNamespacedHelpers('system');

export default {
    props: {
        automation: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapStateSystem(['errorsHandler']),
    },
    methods: {
        ...popupPanelMapActions(['open']),
        handleEdit() {
            this.$router.push({
                name: 'automations.flow.builder',
                params: { id: this.automation.id },
            });
        },
        handleDuplicate() {
            duplicateAutomation(this.automation.id)
                .then((response) => {
                    this.$router.push({
                        name: 'automations.flow.builder',
                        params: { id: response.data.id },
                    });
                })
                .catch((error) => {
                    this.errorsHandler.handleError(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('common.labels.toast.error'),
                    });
                });
        },
        handleDelete() {
            this.open({
                key: 'automationDeleteDialog',
                props: {
                    automation: this.automation,
                },
            });
        },
    },
};
</script>

<style lang="scss">
.compass-menu__dropdown__container.automation-listing-table-actions__menu {
    z-index: 3;
}
</style>
